import { lazy } from 'react'
import reducer from './state/reducers'
import { getStore } from '@AppRedux/store'
import { WEBHRIS_OLD_DASHBOARD_URL } from '../../../config/settings';
import checkAuth from '@Utils/checkAuth';

const store = getStore();
const Dashboard = lazy(() =>
    import(/* webpackChunkName: "IncAdjList" */ './Home').then(async module => {
        // wait for fetching userinfo before rendering
        store.injectReducer('dashboard', reducer.homeReducer)
        return module
    })
)

const DashboardRoutes = [
    {
        label: 'Dashboard',
        path: '/',
        component: Dashboard,
        icon: 'fa-home',
        exact: true,
        showNav: false,
        public: false,
    },
]

export default DashboardRoutes